export default "__VITE_ASSET__9Y9DuDRR__"